import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import lagescoresColorsIntensity from '../../../utils/lagescores-colors';

/* eslint-disable max-len */
const Bars = ({ viva, newScore, layerName, fadeColor }) => {
  const [barColor, setBarColor] = useState();
  const [colorRange] = useState(lagescoresColorsIntensity[layerName]);

  useEffect(() => {
    // const selectColorRange = (score) => {
    //   setBarColor(colorRange[Math.ceil(score)]);
    // };
    if (layerName === 'ÖPNV') {
      setBarColor(colorRange[4]);
    } else {
      setBarColor(colorRange[5]);
    }
    // if (layerName) {
    //   selectColorRange(newScore);
    // }
  }, [colorRange, layerName, newScore]);
  return (
    <div className="scorebars">
      <div
        className={`scorebars__container ${
          newScore === 0 && 'scorebars__container-null'
        }`}
        style={
          viva === 2
            ? { border: `1px solid ${fadeColor ? '#B2B5B5' : barColor}` }
            : {}
        }
      >
        {newScore > 0 && (
          <div
            className="scorebars__bars scorebars__bars--left"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
        {newScore > 0.5 && (
          <div
            className="scorebars__bars scorebars__bars--right"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
      </div>
      <div
        className={`scorebars__container ${
          newScore === 0 && 'scorebars__container-null'
        }`}
        style={
          viva === 2
            ? { border: `1px solid ${fadeColor ? '#B2B5B5' : barColor}` }
            : {}
        }
      >
        {newScore > 1 && (
          <div
            className="scorebars__bars scorebars__bars--left"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
        {newScore > 1.5 && (
          <div
            className="scorebars__bars scorebars__bars--right"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
      </div>
      <div
        className={`scorebars__container ${
          newScore === 0 && 'scorebars__container-null'
        }`}
        style={
          viva === 2
            ? { border: `1px solid ${fadeColor ? '#B2B5B5' : barColor}` }
            : {}
        }
      >
        {newScore > 2 && (
          <div
            className="scorebars__bars scorebars__bars--left"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
        {newScore > 2.5 && (
          <div
            className="scorebars__bars scorebars__bars--right"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
      </div>
      <div
        className={`scorebars__container ${
          newScore === 0 && 'scorebars__container-null'
        }`}
        style={
          viva === 2
            ? { border: `1px solid ${fadeColor ? '#B2B5B5' : barColor}` }
            : {}
        }
      >
        {newScore > 3 && (
          <div
            className="scorebars__bars scorebars__bars--left"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
        {newScore > 3.5 && (
          <div
            className="scorebars__bars scorebars__bars--right"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
      </div>
      <div
        className={`scorebars__container ${
          newScore === 0 && 'scorebars__container-null'
        }`}
        style={
          viva === 2
            ? { border: `1px solid ${fadeColor ? '#B2B5B5' : barColor}` }
            : {}
        }
      >
        {newScore > 4 && (
          <div
            className="scorebars__bars scorebars__bars--left"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
        {newScore > 4.5 && (
          <div
            className="scorebars__bars scorebars__bars--right"
            style={
              viva === 2
                ? { backgroundColor: fadeColor ? '#B2B5B5' : barColor }
                : {}
            }
          />
        )}
      </div>
    </div>
  );
};

Bars.propTypes = {
  viva: PropTypes.number,
  newScore: PropTypes.number,
  layerName: PropTypes.string,
  fadeColor: PropTypes.bool,
};

Bars.defaultProps = {
  newScore: 3,
  viva: 0,
  layerName: 'Wohnlage',
  fadeColor: false,
};

export default Bars;
